import Image from 'next/image';

import VerifyIcon from '@/assets/verified-blue.svg';
import VBImage from '@/components/images/VBImage';
import type CompanyProps from '@/types/Company.type';
import { getMainHQLocation } from '@/utils/helper';

import RelatedCompanyIndustries from './RelatedCompanyIndustries';

interface RelatedCompanyProps {
  company: CompanyProps;
}
export default function RelatedCompany({ company }: RelatedCompanyProps) {
  const { name, logo } = company;

  return (
    <div className="h-full rounded-xl bg-white pb-5 shadow-gray-900/50 transition-shadow hover:shadow-xl">
      <div className="h-20 rounded-t-xl bg-sky-900">
        <div className="py-4 px-6">
          <div className="mt-4 flex flex-row items-baseline justify-between">
            <div className="h-24 w-24 overflow-hidden rounded-xl border border-gray-200 bg-white">
              {logo && logo.url && (
                <VBImage src={logo.url} size={150} alt={'image'} />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 px-6 pt-4">
        <div className="flex flex-row content-center items-center">
          <h1 className="text-lg font-bold capitalize text-black">{name}</h1>
          <div className="ml-2 flex">
            <Image
              className="flex-none"
              src={VerifyIcon}
              alt="verified"
              width={20}
              height={20}
            />
          </div>
        </div>
        <h6 className="mt-1 mb-0 flex flex-row items-center text-base font-medium text-gray-800 line-clamp-1">
          <span>{company.founding_year}</span>
          <span className="mx-2 inline-block h-1 w-1 rounded-full bg-gray-800 align-middle"></span>
          <span className="capitalize">
            {getMainHQLocation(company.specific_locations)}
          </span>
        </h6>
        <p className="mt-1 text-base line-clamp-3">
          {company.short_description}
        </p>
      </div>
      <div className="mt-2">
        <RelatedCompanyIndustries industries={company.industries || []} />
      </div>
    </div>
  );
}
